import { Steps } from 'antd'

import { RegisterForm } from './Form'
import { useRegisterStore } from './hooks/useStore'
import { RegisterQrcode } from './Qrcode'
import { RegisterResult } from './Result'
import { useRegisterStyles } from './style'

const items = [
  {
    title: '扫码注册',
    description: '微信扫码'
  },
  {
    title: '绑定手机',
    description: '校验并绑定手机号码'
  },
  {
    title: '注册成功',
    description: '完成操作'
  }
]

export const Register = () => {
  const current = useRegisterStore(state => state.current)

  const { styles } = useRegisterStyles()

  return (
    <div className={styles.container}>
      <Steps current={current} items={items} />
      <div className={styles.content}>
        {current === 0 && <RegisterQrcode />}
        {current === 1 && <RegisterForm />}
        {current === 2 && <RegisterResult />}
      </div>
    </div>
  )
}
